module.exports = __webpack_public_path__ + "media/images/country_flags/ve-dd714e593785bd6c1c5bc55ae5b16007.png";